// projects/humanresources-payroll/src/assets/i18n/*/hr-pay-period-date.json
export class HrPayPeriodDateKey {
    private static readonly keyPrefix = 'hrPayPeriodDate';
    public static pageHeader = `${HrPayPeriodDateKey.keyPrefix}.pageHeader`;
    public static payrollSwitch = `${HrPayPeriodDateKey.keyPrefix}.payrollSwitch`;
    public static year = `${HrPayPeriodDateKey.keyPrefix}.year`;
    public static period = `${HrPayPeriodDateKey.keyPrefix}.period`;
    public static paymentDate = `${HrPayPeriodDateKey.keyPrefix}.paymentDate`;
    public static preYear = `${HrPayPeriodDateKey.keyPrefix}.preYear`;
    public static prePeriod = `${HrPayPeriodDateKey.keyPrefix}.prePeriod`;
}
